<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { MAIN_MENU_ITEMS } from '@/constants'
import { useClinicStore } from '@/stores'
import { NavigationType } from '@/types'
import { Icon, SidebarGroup, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/ui'

const route = useRoute()
const clinicsStore = useClinicStore()
const { permissions, currentClinic } = storeToRefs(clinicsStore)

const menuItems = computed(() => {
  const result = {} as NavigationType

  Object.keys(MAIN_MENU_ITEMS).forEach(key => {
    const items = MAIN_MENU_ITEMS[key].filter(
      item =>
        (typeof item.to !== 'string' || !currentClinic.value?.exclude_navigations?.includes(item.to)) &&
        (!item.permission || permissions.value?.[item.permission])
    )

    if (items.length) {
      result[key] = items
    }
  })

  return result
})
</script>

<template>
  <SidebarGroup v-for="(items, label) in menuItems" :key="label" class="border-t [&:first-child]:border-none">
    <SidebarGroupLabel>{{ label }}</SidebarGroupLabel>
    <SidebarMenu>
      <SidebarMenuItem v-for="item in items" :key="item.text">
        <RouterLink :to="item.to as string">
          <SidebarMenuButton
            :tooltip="item.text"
            as="span"
            :class="[
              'p-0 hover:bg-slate-200',
              { 'bg-slate-200': item.to === route.path },
              'flex w-full items-center gap-2 p-2',
            ]"
          >
            <Icon :name="item.icon" class="mr-2 size-4" lib="solid" />
            <span>{{ item.text }}</span>
          </SidebarMenuButton>
        </RouterLink>
      </SidebarMenuItem>
    </SidebarMenu>
  </SidebarGroup>
</template>
